export enum HelpTopicType{
    PopUp = 1,
    FAQ = 2
}